import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Safe area spacer with header background color */}
      <div className="bg-primary-800 safe-area-top" />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <div className="safe-area-bottom bg-gray-50" />
    </div>
  );
}
